module.exports = __webpack_public_path__ + "img/jq_2.dfe17f23.jpg";